export class MapPositions {
    static ALL = 'all';
    static MAIN = 'main';
    static GALLERY = 'gallery';
    // Erweitere hier neue Positionen:
    // static FULLSCREEN = 'fullscreen';
    // static PRINT = 'print';

    constructor(initial = MapPositions.MAIN) {
        this.allowed = [MapPositions.MAIN, MapPositions.GALLERY];
        this.current = initial;
    }

    set(pos) {
        if(!this.allowed.includes(pos)) { throw new Error(`Unknown map position: ${pos}`); }
        this.current = pos;
    }

    get() { return this.current; }

    is(pos) { return this.current === pos; }
    isMain() { return this.current === MapPositions.MAIN; }
    isGallery() { return this.current === MapPositions.GALLERY; }

    // Zum Testen/Skripten: alle erlaubten Positionen holen
    getAllowed() { return [...this.allowed]; }
}